import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CapIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Cap",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "m23.16 17.51-6.51 2.36q-.285.09-.63.09c-.345 0-.44-.03-.65-.1h.02l-.63-.22-3.88-1.43-1.99-.73-.87-.31v3.23c0 1.19.79 2.39 2.34 3.29.1.05.2.09.29.13 1.24.59 2.68 1.01 4.19 1.21h.07c.33.04.72.05 1.11.05s.78-.02 1.16-.05h-.05c1.59-.18 3.04-.59 4.38-1.2l-.09.04c.09-.04.19-.08.29-.13 1.56-.87 2.34-2.09 2.34-3.29v-3.29l-.88.34Zm6.32-5.84-2.82-1.02-2.52-.87-3.28-1.23 1.26.45-3.58-1.3-1.16-.43.27.1-.37-.14-.63-.23q-.285-.09-.63-.09c-.345 0-.44.03-.65.1h.02l-.63.22-1.26.46-3.62 1.3-2.52.87-4.85 1.75c-.69.25-.69.66 0 .87l4.85 1.75 2.52 1.02 3.58 1.3 1.26.46.63.23q.285.09.63.09c.345 0 .44-.03.65-.1h-.02l.63-.22 1.26-.46 2.88-1.04 4.83-1.76v6.65c0 .72.59 1.31 1.31 1.31s1.31-.59 1.31-1.31v-7.62l.63-.23c.71-.24.71-.65.02-.9Zm-12.24 1.17c-.36.19-.79.29-1.24.29s-.88-.11-1.26-.3h.02c-.3-.1-.51-.38-.51-.71s.21-.61.51-.71c.36-.19.79-.3 1.24-.3s.88.11 1.26.3h-.02a.75.75 0 0 1 .02 1.42Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M27.78 7.5 17.5 4.75c-.97-.26-1.99-.26-2.96 0L1.95 8.13A2.59 2.59 0 0 0 0 10.64c0 1.2.77 2.22 1.94 2.53l12.6 3.38c.97.27 1.99.26 2.96 0l9.12-2.44c.61-.16.97-.79.81-1.4s-.8-.97-1.4-.81l-9.13 2.44c-.58.16-1.18.16-1.76 0l-12.6-3.38c-.16-.04-.24-.15-.24-.31 0-.24.18-.29.24-.3l12.6-3.38c.58-.16 1.18-.16 1.76 0l10.28 2.75c1.49.4 2.53 1.76 2.53 3.3v11.72a1.14 1.14 0 1 0 2.28 0V13.02c0-2.58-1.74-4.84-4.23-5.52Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M25.14 17.15c-.63 0-1.14.51-1.14 1.14v4.24c0 .46-.26.88-.65 1.05-4.94 2.11-9.75 2.11-14.7 0C8.26 23.42 8 23 8 22.54V18.3c0-.63-.51-1.14-1.15-1.14s-1.15.51-1.15 1.14v4.24c0 1.39.81 2.63 2.05 3.15 2.74 1.17 5.49 1.75 8.25 1.75s5.51-.58 8.24-1.75c1.25-.53 2.05-1.76 2.05-3.16v-4.24c0-.63-.51-1.14-1.14-1.14Z"
      })]
    })
  }));
};